<template>
  <v-app>
    <v-container>
      <v-data-table
        :headers="headers"
        :items="precosMascarados"
        :items-per-page="10"
        class="elevation-1"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.codigo }}</td>
            <td>{{ item.nome }}</td>
            <td>{{ item.qtde }}</td>
            <td>{{ item.venda_total }}</td>
            <td>{{ item.custo_total }}</td>
            <td>{{ item.venda_liquida }}</td>
          </tr>
        </template>
        <template slot="body.append">
          <tr class="blue--text">
            <th class="title">Totais</th>
            <th class="title"></th>
            <th class="title">{{ sumField("qtde") }}</th>
            <th class="title">{{ sumField("venda_total") }}</th>
            <th class="title">{{ sumField("custo_total") }}</th>
            <th class="title">{{ sumField("venda_liquida") }}</th>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </v-app>
</template>

<script>
import { maskMoney, maskQtd } from "@/utils/masks";

export default {
  data() {
    return {
      headers: [
        { text: "Cód", value: "codigo" },
        { text: "Seção", value: "nome" },
        { text: "Qtde.", value: "qtde" },
        { text: "Venda Total", value: "venda_total" },
        { text: "Custo Total", value: "custo_total" },
        { text: "Venda Líquida", value: "venda_liquida" },
      ],
    };
  },
  computed: {
    precosMascarados() {
      return this.relatorio.map((venda) => {
        return {
          ...venda,
          venda_total: maskMoney(venda.venda_total),
          venda_liquida: maskMoney(venda.venda_liquida),
          custo_total: maskMoney(venda.custo_total),
        };
      });
    },
    relatorio() {
      return this.$store.state.relatorio.relatorioPainelVendasSecoes;
    },
  },
  methods: {
    sumField(field) {
      let total = 0;
      if (this.relatorio) {
        total = this.relatorio.reduce(
          (accumulator, item) => accumulator + Number(item[field]),
          0
        );
      }
      return maskQtd(total);
    },
  },
};
</script>
